export default "__VITE_ASSET__yO3bmg86__"